var map = {
	"./Salad.jpeg": 279,
	"./Salmon.jpeg": 4036,
	"./Wrap.jpeg": 3538,
	"./beer_flight.jpg": 486,
	"./burger.JPG": 5457,
	"./pizza.JPG": 2578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5909;